/**
 * Example ingredient lists for "Try an example" CTAs.
 * Each example demonstrates different allergen categories.
 */
export const examples: Record<string, string> = {
  bakery: 'Wheat flour, sugar, butter (milk), eggs, baking powder, vanilla extract, soy lecithin, tree nuts (almonds)',
  chocolate: 'Cocoa mass, sugar, cocoa butter, milk powder, soy lecithin (E322), hazelnuts, may contain traces of peanuts',
  baby: 'Rice flour, oat flour, dried skimmed milk, glucose syrup, sunflower oil, calcium carbonate, vitamin D, iron, fish oil',
  sauce: 'Water, tomato paste, sugar, spirit vinegar, modified corn starch, mustard flour, celery salt, sulphur dioxide (E220)',
  seafood: 'Shrimp (crustaceans), wheat flour, vegetable oil, garlic powder, paprika, celery seed, anchovy paste (fish), sulphites',
};

export const exampleDescriptions: Record<string, string> = {
  bakery: 'Bakery product — wheat, milk, eggs, soy, tree nuts',
  chocolate: 'Chocolate bar — milk, soy, hazelnuts, peanut traces',
  baby: 'Baby food — milk, fish, gluten',
  sauce: 'Sauce — mustard, celery, sulphites',
  seafood: 'Breaded shrimp — crustaceans, wheat, fish, sulphites',
};
